var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"theme",rawName:"v-theme",value:(Object.assign({},_vm.cardStyle)),expression:"Object.assign({},cardStyle)"}],staticClass:"com-iframe",style:(_vm.cardStyle),domProps:{"innerHTML":_vm._s(_vm.dataInfo.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }